import * as actions from './actions'
import * as getters from './getters'
import * as mutations from './mutations'
import { OrderAssignmentState } from '@/services/models/order-assignments-model'

export const createInitialState = () => ({
  orderAssignments: [],
  pagination: {
    totalCount: 0,
    pageNumber: 1,
    nextPageNumber: null,
    previousPageNumber: null
  },
  filters: {},
  lastRefreshed: null,
  updatesCount: 0,
  status: OrderAssignmentState.Pending
})

export default {
  state: createInitialState(),
  getters,
  mutations,
  actions
}
